module.exports = __webpack_public_path__ + "static/media/prism flyer.a4ca2972.png";